'use strict';

var React = require('react');
var button = require('@amzn/stencil-react-components/button');
var layout = require('@amzn/stencil-react-components/layout');
var text = require('@amzn/stencil-react-components/text');
require('@amzn/stencil-react-theme-default');
var context = require('@amzn/stencil-react-components/context');
var utils = require('@amzn/stencil-react-components/utils');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*
 * NOTE:
 *
 * This source file was temporarily copied from the 'native-components' package.  Minimal changes
 * were made to use the Stencil web package and associated APIs to provide web support for this
 * component.  This is phase 1 of a multi-phase process to align Stencil native and web APIs so
 * we can more easily manage a single code base for both native and web.  When possible, this
 * component will be re-unified with its native counterpart and duplicate code removed.
 *
 * Ref: https://sim.amazon.com/issues/AtoZPirates-483
 */
var ColButtonCtr = context.styledWithTheme(layout.Col)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    paddingLeft: utils.px(selectors.space('S400')),
    paddingRight: utils.px(selectors.space('S400'))
  };
});
var ColErrorMessage = context.styledWithTheme(layout.Col)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    paddingLeft: utils.px(selectors.space('S500')),
    paddingRight: utils.px(selectors.space('S500'))
  };
});
var ColErrorCtr = context.styledWithTheme(layout.Col)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    alignItems: 'center',
    height: '100%',
    justifyContent: 'space-between',
    maxWidth: '768px',
    paddingBottom: utils.px(selectors.space('S500')),
    paddingTop: utils.px(selectors.space('S500'))
  };
});
var TextErrorHeadingMessage = context.styledWithTheme(text.Text)(function (_ref4) {
  var selectors = _ref4.theme.selectors;
  return {
    marginBottom: utils.px(selectors.space('S300'))
  };
});
var ViewImageCtr = context.styledWithTheme(layout.View)(function () {
  return {
    flexShrink: 1,
    marginBottom: '10px',
    marginTop: '10px'
  };
});

var ErrorPage = function ErrorPage(_ref5) {
  var errorBody = _ref5.errorBody,
      errorTitle = _ref5.errorTitle,
      retryHandler = _ref5.retryHandler,
      retryButtonText = _ref5.retryButtonText,
      onRender = _ref5.onRender,
      children = _ref5.children;
  React.useEffect(function () {
    if (onRender) {
      onRender();
    }
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(layout.Col, {
    alignItems: "center",
    backgroundColor: "primary05",
    width: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(ColErrorCtr, null, /*#__PURE__*/React__default["default"].createElement(ColErrorMessage, null, /*#__PURE__*/React__default["default"].createElement(TextErrorHeadingMessage, {
    color: "neutral100",
    fontSize: "T500",
    fontWeight: "medium"
  }, errorTitle), /*#__PURE__*/React__default["default"].createElement(text.Text, {
    color: "neutral80",
    fontSize: "T300"
  }, errorBody)), /*#__PURE__*/React__default["default"].createElement(ViewImageCtr, null, children), /*#__PURE__*/React__default["default"].createElement(ColButtonCtr, null, /*#__PURE__*/React__default["default"].createElement(button.Button, {
    variant: button.ButtonVariant.Primary,
    onClick: retryHandler
  }, retryButtonText))));
};

exports.ErrorPage = ErrorPage;
//# sourceMappingURL=ErrorPage-cdbc6fa1.js.map
